// extracted by mini-css-extract-plugin
export default {"searchForm":"ChangePasswordModal_searchForm__uWNvy","tips":"ChangePasswordModal_tips__FbbcL"};